export default __webpack_public_path__ + "static/media/Balls left.f5ad7ee1.svg";